import * as Yup from "yup";
import { CategoryInitialValue, FoodInitialValue, LockerInitialValue, OfferInitialValue, PlanInitialValue, ProjectInitialValue, ProjectListData, RechargeInitialValue, RfidCardInitialValue, TicketOfferInitialValue } from "../../../Types/Application/ProjectList/ProjectList";

export const projectData:ProjectListData[] =  [
    {
        id: 1,
        title: "Endless admin Design",
        badge: "Doing",
        image: "3.jpg",
        sites: "Themeforest, australia",
        description: "Endless Admin is a full featured, multipurpose, premium bootstrap admin template.",
        issue: "12",
        resolved: "5",
        comment: "7",
        like: "10",
        progress: 70,
        customers_image1: "3.jpg",
        customers_image2: "5.jpg",
        customers_image3: "1.jpg",
        color:"primary"
    },
    {
        id: 2,
        title: "Universal admin Design",
        badge: "Done",
        image: "3.jpg",
        sites: "Themeforest, australia",
        description: "Universal Admin is a full featured, multipurpose, premium bootstrap admin template.",
        issue: "24",
        resolved: "24",
        comment: "40",
        like: "3",
        progress: 100,
        customers_image1: "3.jpg",
        customers_image2: "5.jpg",
        customers_image3: "1.jpg",
        color:"secondary"
    },
    {
        id: 3,
        title: "Poco admin Design",
        badge: "Done",
        image: "3.jpg",
        sites: "Themeforest, australia",
        description: "Poco Admin is a full featured, multipurpose, premium bootstrap admin template.",
        issue: "40",
        resolved: "40",
        comment: "20",
        like: "2",
        progress: 100,
        customers_image1: "3.jpg",
        customers_image2: "5.jpg",
        customers_image3: "1.jpg",
        color:"success"
    },
    {
        id: 4,
        title: "Universal admin Design",
        badge: "Done",
        image: "3.jpg",
        sites: "Themeforest, australia",
        description: "Universal Admin is a full featured, multipurpose, premium bootstrap admin template.",
        issue: "24",
        resolved: "24",
        comment: "40",
        like: "3",
        progress: 100,
        customers_image1: "3.jpg",
        customers_image2: "5.jpg",
        customers_image3: "1.jpg",
        color:"primary"
    },
    {
        id: 5,
        title: "Endless admin Design",
        badge: "Doing",
        image: "3.jpg",
        sites: "Themeforest, australia",
        description: "Endless Admin is a full featured, multipurpose, premium bootstrap admin template.",
        issue: "12",
        resolved: "5",
        comment: "7",
        like: "10",
        progress: 70,
        customers_image1: "3.jpg",
        customers_image2: "5.jpg",
        customers_image3: "1.jpg",
        color:"secondary"
    },
    {
        id: 6,
        title: "Poco admin Design",
        badge: "Done",
        image: "3.jpg",
        sites: "Themeforest, australia",
        description: "Poco Admin is a full featured, multipurpose, premium bootstrap admin template.",
        issue: "40",
        resolved: "40",
        comment: "20",
        like: "2",
        progress: 100,
        customers_image1: "3.jpg",
        customers_image2: "5.jpg",
        customers_image3: "1.jpg",
        color:"success"
    }
]

export const projectInitialValue: ProjectInitialValue = {
    title: "",
    client: "",
    progress: 0,
    type: "",
    priority: "",
    size: "",
    description: "",
  };
  
  export const projectValidation = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    client: Yup.string().required("Client Name is required"),
    description: Yup.string().required("Some Details is required"),
    progress: Yup.number().required("Between 0 to 100").max(100),
  });

  export const planInitialValue: PlanInitialValue = {
    title: "",
    ticket_price:0,
    seasonal_price: 0,
    seasonal_status:"true",
    clothPrice: "0",
  };
  
  export const planValidation = Yup.object().shape({
    title: Yup.string().required("Plan name is required"),
    ticket_price: Yup.number().required("Ticket Price is required"),
    seasonal_price: Yup.number().required("Ticket Seasonal Price is required"),
  });

  export const offerInitialValue: OfferInitialValue = {
    title: "",
    offer_type: 1,
    offer_discount: 0,
    originalPrice: 0,
  };
  
  export const offerValidation = Yup.object().shape({
    title: Yup.string().required("Offer title is required"),
    offer_type: Yup.number().required("Offer Type is required"),
    offer_discount: Yup.number().required("Offer discount is required"),
    originalPrice: Yup.number().required("Offer limit price is required"),
  });

  export const ticketOfferInitialValue: TicketOfferInitialValue = {
    offerName: "",
    freeType: "Adult",
    totalFree: 0,
    totalCount: 0,
    adultBuy: 0,
    childBuy: 0,
  };
  
  export const ticketOfferValidation = Yup.object().shape({
    offerName: Yup.string().required("Offer name is required"),
    totalFree: Yup.number().required("total free ticket is required"),
    totalCount: Yup.number().required("total number of ticket is required"),
  });

  export const rfidCardInitialValue: RfidCardInitialValue = {
    title: "",
  };
  
  export const rfidCardValidation = Yup.object().shape({
    title: Yup.string().required("RFID Card number is required"),
  });

  export const lockerInitialValue: LockerInitialValue = {
    title: 0,
    locker_size: "",
    locker_price: 0,
    securityCharges: "",
  };
  
  export const lockerValidation = Yup.object().shape({
    title: Yup.number().required("Locker number is required"),
    locker_size: Yup.string().required("Select Locker Size"),
    locker_price: Yup.number().required("Locker Price is required"),
  });

  export const rechargeInitialValue: RechargeInitialValue = {
    cardAmount: "",
  };
  
  export const rechargeValidation = Yup.object().shape({
    cardAmount: Yup.string().required("Amount is required"),
  });

  export const categoryInitialValue: CategoryInitialValue = {
    categoryName: "",
  };
  
  export const categoryValidation = Yup.object().shape({
    categoryName: Yup.string().required("Category Name is required"),
  });

  export const foodInitialValue: FoodInitialValue = {
    foodCategoryId:"",
    sellingprice:"",
    discountprice: "",
    foodname:"",
    images: "",
  };
  
  export const foodValidation = Yup.object().shape({
    foodCategoryId: Yup.string().required("Please select Category"),
    foodname: Yup.string().required("Food Name is required"),
    sellingprice: Yup.number().required("Food Price is required"),
    // images: Yup.string().required("Image is required"),
  });